import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Paper,
} from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Footer from "../Footer/Footer";
import Swal from "sweetalert2";
import { changePassword } from "../Services/AuthService";
import { useNavigate } from "react-router-dom";
import {
  validatePassword,
  validateConfirmPassword,
} from "../utils/validationUtils";

const ChangePasswordScreen = () => {
  const [formData, setFormData] = useState({
    userId: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({
    userId: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const handleToggleVisibility = (field: string) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field as keyof typeof prev],
    }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const validate = () => {
    let isValid = true;
    const newErrors: any = {};

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!formData.userId) {
      newErrors.userId = "User ID is required.";
      isValid = false;
    }

    if (!formData.currentPassword) {
      newErrors.currentPassword = "Current password is required.";
      isValid = false;
    }

    // if (!formData.newPassword) {
    //   newErrors.newPassword = "New password is required.";
    //   isValid = false;
    // } else if (!passwordRegex.test(formData.newPassword)) {
    //   newErrors.newPassword =
    //     "Password must be at least 8 characters, include uppercase, lowercase, number, and special character.";
    //   isValid = false;
    // }
    const passwordError = validatePassword(formData.newPassword);
    if (passwordError) {
      newErrors.newPassword = passwordError;
      isValid = false;
    }

    // if (!formData.confirmPassword) {
    //   newErrors.confirmPassword = "Please confirm your new password.";
    //   isValid = false;
    // } else if (formData.newPassword !== formData.confirmPassword) {
    //   newErrors.confirmPassword = "Passwords do not match.";
    //   isValid = false;
    // }
    const confirmError = validateConfirmPassword(
      formData.newPassword,
      formData.confirmPassword
    );
    if (confirmError) {
      newErrors.confirmPassword = confirmError;
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const response = await changePassword({
        userId: formData.userId,
        oldPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });
      Swal.fire({
        icon: "success",
        title: "Password Changed",
        text: response.message,
      });

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("orgId");
      localStorage.removeItem("orgName");
      localStorage.clear();
      sessionStorage.clear(); // Clear session storage as well
      navigate("/", { replace: true }); // Redirect to login page
    } catch (error: any) {
      alert(error.message);
    }
  };

  return (
    <>
      {/* <div className="container"> */}
        <div className="page-location">
          <span>Admin &gt; Change Password</span>
        </div>
        <Container maxWidth="sm">
          <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
            <Typography
              variant="h5"
              align="center"
              sx={{
                fontWeight: "bold",
                color: "black",
              }}
            >
              <LockOutlined sx={{ mr: 1 }} />
              {/* Change Password */}
            </Typography>
            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                margin="normal"
                label="User ID"
                name="userId"
                type="text"
                value={formData.userId}
                onChange={handleChange}
                error={!!errors.userId}
                helperText={errors.userId}
              />

              {["currentPassword", "newPassword", "confirmPassword"].map(
                (field) => (
                  <TextField
                    key={field}
                    fullWidth
                    margin="normal"
                    label={
                      field === "currentPassword"
                        ? "Current Password"
                        : field === "newPassword"
                        ? "New Password"
                        : "Confirm Password"
                    }
                    type={
                      showPassword[field as keyof typeof showPassword]
                        ? "text"
                        : "password"
                    }
                    name={field}
                    value={formData[field as keyof typeof formData]}
                    onChange={handleChange}
                    error={!!errors[field as keyof typeof errors]}
                    helperText={errors[field as keyof typeof errors]}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => handleToggleVisibility(field)}
                          >
                            {showPassword[
                              field as keyof typeof showPassword
                            ] ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )
              )}
              <Button
                variant="contained"
                type="submit"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                Change Password
              </Button>
            </Box>
          </Paper>
        </Container>
      {/* </div> */}
      <div style={{ marginTop: "100px" }}>
        <Footer />
      </div>
    </>
  );
};

export default ChangePasswordScreen;
